import { Carousel } from "react-carousel-minimal";

function CarouselImages({ images, thumbnails }) {
  const coverImage = images.find((image) => image.cover);
  const nonCoverImages = images.filter((image) => !image.cover);
  const arrayImages = [coverImage, ...nonCoverImages];
  const data = arrayImages.map((arrayImage) => {
    return {
      image: arrayImage.url,
    };
  });

  const slideNumberStyle = {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#dfe4ea",
    position: "absolute",
    right: "0",
    bottom: "0",

    textShadow:
      "3px 3px 0 #000,-1px -1px 0 #000, 1px -1px 0 #000,-1px 1px 0 #000,1px 1px 0 #000",
  };
  return (
    <div className="App">
      <div>
        <Carousel
          data={data}
          time={3000}
          width="100%"
          radius="10px"
          slideNumber={true}
          slideNumberStyle={slideNumberStyle}
          automatic={true}
          dots={true}
          pauseIconColor="white"
          pauseIconSize="40px"
          slideBackgroundColor="darkgrey"
          slideImageFit="cover"
          thumbnails={thumbnails}
          thumbnailWidth="25%"
          style={{
            textAlign: "center",
            maxWidth: "100%",
            maxHeight: "100%",
            margin: "40px auto",
          }}
        />
      </div>
    </div>
  );
}

export default CarouselImages;
